import axios, { AxiosRequestConfig } from 'axios';
import store from '@/store/';
import router from '@/router/';

const appAxios = axios.create({
    headers: {'Content-Type': 'application/vnd.api+json'},
    proxy: false,
    withCredentials: false,
});

appAxios.interceptors.request.use((config: AxiosRequestConfig) => {
    // @ts-ignore
    if (config.url.includes('auth/')) {
        return config;
    }
    if (store.getters['user/switchedUserEmail']) {
        if (!config.url) {
            return config;
        }
        if (config.url.includes('users/')) {
            const originalUsername = config.url.split('/')[1].split('?')[0];
            const switchedUserEmail = store.getters['user/switchedUserEmail'];
            config.url = config.url.replace(originalUsername, switchedUserEmail);
        }
        const configUrl = new URL(config.baseURL + '/' + config.url);
        const username = store.getters['user/switchedUserEmail'];
        configUrl.searchParams.append('_switch_user', username);
        config.url = configUrl.href;
    }
    return config;
});

appAxios.interceptors.response.use((response) => {
    return response;
}, (error) => {
    if (error.response && error.response.status === 401) {
        store.dispatch('user/logoutUser');
        router.push({name: 'Login'});
        return;
    }
    return Promise.reject(error);
});

export { appAxios };
